<script setup>
import { emit } from 'process';
import { CheckIcon } from '@heroicons/vue/20/solid';

const props = defineProps({
  steps: {
    required: true,
  },
  size: {
    required: true,
  },
});

defineEmits(['requestStepShortcut']);

const sizeClass = ['h-24', 'w-24'];
</script>

<template>
  <ol
    role="list"
    class="flex items-center justify-center"
  >
    <li
      v-for="(step, stepIdx) in steps"
      :key="step.name"
      :class="[stepIdx !== steps.length - 1 ? 'pr-8 md:pr-32 xl:pr-64' : '', 'relative']"
    >
      <template v-if="step.isDone()">
        <div
          class="absolute inset-0 flex items-center"
          aria-hidden="true"
        >
          <div class="h-0.5 w-full bg-basecolor" />
        </div>
        <a
          @click.prevent="$emit('requestStepShortcut', stepIdx)"
          :class="[sizeClass, 'cursor-pointer']"
          class="relative flex items-center justify-center rounded-full border-1 bg-basecolor border-basecolor"
        >
          <span
            class="rounded-full bg-basecolor"
            aria-hidden="true"
          />
          <span class="sr-only">{{ step.name }}</span>
          <span class="text-secondary text-xl"><CheckIcon class="w-12 h-12" /></span>
        </a>
        <div
          class="absolute w-24 uppercase flex items-center justify-center text-sm text-center text-basecolor"
        >
          {{ step.name }}
        </div>
      </template>

      <template v-else-if="step.isCurrent()">
        <div
          class="absolute inset-0 flex items-center"
          aria-hidden="true"
        >
          <div class="h-0.5 w-full bg-registerLight" />
        </div>
        <a
          :class="[sizeClass, 'cursor-pointer']"
          class="relative flex items-center justify-center rounded-full border-1 border-registerLight bg-basecolor"
          aria-current="step"
        >
          <span class="sr-only">{{ step.name }}</span>
          <span class="text-secondary text-2xl">{{ stepIdx + 1 }}</span>
        </a>
        <div
          class="absolute w-24 uppercase font-bold flex items-center justify-center text-sm text-center text-basecolor"
        >
          {{ step.name }}
        </div>
      </template>

      <template v-else>
        <div
          class="absolute inset-0 flex items-center"
          aria-hidden="true"
        >
          <div class="h-0.5 w-full bg-registerLight" />
        </div>
        <a
          :class="sizeClass"
          class="group relative flex items-center justify-center rounded-full border-1 border-registerLight bg-registerLight"
        >
          <span class="sr-only">{{ step.name }}</span>
          <span class="text-secondary text-2xl">{{ stepIdx + 1 }}</span>
        </a>
        <div
          class="absolute w-24 uppercase flex items-center justify-center text-sm text-center text-basecolor"
        >
          {{ step.name }}
        </div>
      </template>
    </li>
  </ol>
</template>
